import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { focusRingInline } from "theme/tokens/accessibility";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  checkboxAnatomy.keys,
);

const getColorStyles = (color: string) => {
  return {
    bg: color,
    borderColor: color,
  };
};

const baseStyleControl = defineStyle({
  position: "relative",
  borderColor: "border.emphasized",
  borderRadius: "sm",
  top: "1px",
  _focus: {
    boxShadow: "none",
  },
  _focusVisible: {
    ...focusRingInline,
  },
  _disabled: {
    color: "fg.muted",
    borderColor: "border.emphasized",
    bg: "bg.container",
    cursor: "default",
  },
  _checked: {
    ...getColorStyles("highlight.solid"),
    color: "fg.inverted",
    _hover: {
      ...getColorStyles("highlight.solid"),
    },
    _focus: {
      boxShadow: "none",
    },
    _disabled: {
      color: "fg.inverted",
      borderColor: "border.emphasized",
      bg: "neutral.emphasized",
      cursor: "default",
    },
  },
  _indeterminate: {
    ...getColorStyles("highlight.solid"),
    color: "fg.inverted",
  },
});

const baseStyleLabel = defineStyle({
  _disabled: {
    opacity: 1,
    cursor: "default",
  },
});

const baseStyleIcon = defineStyle({
  transitionProperty: "opacity, transform",
  transitionDuration: (theme) => theme.transition.duration.extraFast,
  transitionTimingFunction: (theme) => theme.transition.easing.easeOut,
});

export const Checkbox = defineMultiStyleConfig({
  baseStyle: {
    control: baseStyleControl,
    label: baseStyleLabel,
    icon: baseStyleIcon,
  },
});
